import { SlackUser } from 'api/integrations/slack/slack.types';
import { SlackBaseTypes } from '../slack.types';

export interface UserSelectionTypes extends Partial<SlackBaseTypes> {
  usersList?: SlackUser[];
}

export enum UserSelectionOptions {
  AllMembers = 'all_members',
  SelectedMembers = 'selected_members',
}
